/**
 * Reports API: generated endpoints (from the `reports` OpenAPI tag) enhanced
 * with cache tags, plus custom endpoints for the binary/text exports
 * (csv/xlsx/pdf are not representable in the generated JSON client).
 */

import {
  enhancedApi as generatedReportsApi,
  type GetV2ProviderReportsByReportKeyExportApiArg,
} from '@store/generated/reports';

const REPORTS_TAG_TYPES = ['ReportSavedView', 'CompensationConfig', 'ReportAccessMatrix'] as const;

const exportParams = (args: GetV2ProviderReportsByReportKeyExportApiArg) => ({
  start_date: args.startDate,
  end_date: args.endDate,
  basis: args.basis,
  group_by: args.groupBy,
  columns: args.columns,
  sort: args.sort,
  sort_dir: args.sortDir,
  filters: args.filters,
  csv_profile: args.csvProfile,
});

export const reportsApi = generatedReportsApi
  .enhanceEndpoints({
    addTagTypes: REPORTS_TAG_TYPES,
    endpoints: {
      getV2ProviderReportsAccessMatrix: {
        providesTags: [{ type: 'ReportAccessMatrix' as const, id: 'CURRENT' }],
      },
      patchV2ProviderReportsAccessMatrix: {
        invalidatesTags: [{ type: 'ReportAccessMatrix' as const, id: 'CURRENT' }],
      },
      getV2ProviderReportsSavedViews: {
        providesTags: [{ type: 'ReportSavedView' as const, id: 'LIST' }],
      },
      postV2ProviderReportsSavedViews: {
        invalidatesTags: [{ type: 'ReportSavedView' as const, id: 'LIST' }],
      },
      deleteV2ProviderReportsSavedViewsByViewId: {
        invalidatesTags: [{ type: 'ReportSavedView' as const, id: 'LIST' }],
      },
      getV2ProviderReportsCompensationConfig: {
        providesTags: [{ type: 'CompensationConfig' as const, id: 'CURRENT' }],
      },
      putV2ProviderReportsCompensationConfig: {
        invalidatesTags: [{ type: 'CompensationConfig' as const, id: 'CURRENT' }],
      },
    },
  })
  .injectEndpoints({
    endpoints: builder => ({
      exportReportCsvText: builder.query<string, GetV2ProviderReportsByReportKeyExportApiArg>({
        query: args => ({
          url: `/v2/provider/reports/${args.reportKey}/export`,
          params: exportParams(args),
          responseHandler: (response: Response) => response.text(),
        }),
      }),
      exportReportXlsxBlob: builder.query<Blob, GetV2ProviderReportsByReportKeyExportApiArg>({
        query: args => ({
          url: `/v2/provider/reports/${args.reportKey}/export`,
          params: {
            ...exportParams(args),
            format: 'xlsx',
            sheet_by: args.sheetBy,
          },
          responseHandler: (response: Response) => response.blob(),
        }),
      }),
      exportReportPdfBlob: builder.query<Blob, GetV2ProviderReportsByReportKeyExportApiArg>({
        query: args => ({
          url: `/v2/provider/reports/${args.reportKey}/export`,
          params: {
            ...exportParams(args),
            format: 'pdf',
            // The split dimension: one page per value (xlsx: one sheet).
            sheet_by: args.sheetBy,
            tz: args.tz,
          },
          responseHandler: (response: Response) => response.blob(),
        }),
      }),
    }),
    overrideExisting: false,
  });
